module.exports = __webpack_public_path__ + "img/8.94698c58.png";